<page-heading
  [title]="'integrations.agents.title' | translate"
  [description]="'integrations.agents.description' | translate"
  [hasBreadcrumb]="true"
  [breadcrumb]="breadcrumb"
/>

<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <div class="row d-flex justify-content-end">
          <div class="col-xs-12 col-md-6 col-lg-3 btn-group trend-button">
            <button
              class="btn btn-info fw-bold"
              (click)="trendGptCreateAgent(integration)"
            >
              {{ 'integrations.agents.buttonAdd' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

@if (loadingContent) {
<content-loading-list />
}

<div class="card">
  @if (assistants.length === 0) {
  <empty-records-legacy-component
    [labelButton]="'integrations.agents.buttonAdd' | translate"
    [buttonClass]="'btn btn-info fw-bold'"
    [subMessage]="'integrations.agents.emptySubMessage' | translate"
    [message]="'integrations.agents.emptyMessage' | translate"
    (emitEvent)="trendGptCreateAgent(integration)"
  />
  } @if(!loadingContent && assistants.length > 0) {
  <div class="card-body table-responsive">
    <table class="table table-hover table-centered mb-0">
      <thead>
        <tr>
          <th class="text-primary-emphasis">{{ 'integrations.agents.columnCreatedAt' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'integrations.agents.columnAssistantName' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'integrations.agents.columnLinkedChannels' | translate }}</th>
          <th>
            <span class="sr-only"></span>
          </th>
        </tr>
      </thead>
      <tbody>
        @for (assistantObj of assistants; track $index) {
        <tr>
          <td>
            <span>
              {{
                assistantObj.createdAt
                  | timezoneDate
                    : "DD/MM/YYYY"
                    : getTimezoneCompanyCurrentUser()
              }}
            </span>
          </td>
          <td>
            <strong class="text-truncate">{{
              assistantObj.name ?? ('integrations.agents.noName' | translate)
            }}</strong>
          </td>
          <td>
            <span>{{ getChannelsByIdAssistant(assistantObj.id) }}</span>
          </td>
          <td>
            <div class="d-flex justify-content-end">
              <button
                class="btn btn-dropdown-list"
                [matMenuTriggerFor]="menu"
                type="button"
              >
                <i class="mdi mdi-dots-vertical text-primary-emphasis"></i>
              </button>
              <mat-menu #menu="matMenu">
                <button
                  mat-menu-item
                  tabindex="0"
                  (click)="trendGptEditAgent(integration, assistantObj)"
                >
                  {{ 'integrations.agents.menuEdit' | translate }}
                </button>
                <button
                  mat-menu-item
                  tabindex="0"
                  (click)="deleteAgent(assistantObj)"
                >
                  {{ 'integrations.agents.menuRemove' | translate }}
                </button>
              </mat-menu>
            </div>
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>
  }
</div>
